<template>
    <Layout>
        <!-- start page title -->
        <div class="row">
            <div class="col-12">
                <div class="page-title-box d-flex align-items-center justify-content-between">
                    <h4 class="mb-0 font-size-18">Dashboard</h4>

                    <div class="page-title-right">
                        <ol class="breadcrumb m-0">
                            <li class="breadcrumb-item active">Dashboard</li>
                        </ol>
                    </div>
                </div>
            </div>
        </div>
        <!-- end page title -->

        <!-- メニューを動的に生成 -->
        <div class="row">
            <div class="col-lg-4" v-for="menu in filteredMenuItems" :key="menu.id">
                <div class="card">
                    <div class="card-body">
                        <h4 class="card-title">{{ menu.label }}</h4>
                        <p class="card-title-desc">{{ menu.description }}</p>
                        <div class="d-grid gap-2">
                            <b-button v-for="subItem in menu.subItems" :key="subItem.id" block variant="primary"
                                class="font-size-14" @click="toPage(subItem.link)">
                                {{ subItem.label }}
                            </b-button>
                        </div>
                    </div>
                </div>
            </div>
        </div>

        <div v-if="loading" class="modal-mask">
            <vue-loading type="spiningDubbles" color="#eee" :size="{ width: '50px', height: '50px' }"></vue-loading>
        </div>
    </Layout>
</template>

<script>
import Layout from "../layouts/main";
import { VueLoading } from "vue-loading-template";

export default {
    components: {
        Layout,
        VueLoading,
    },
    data() {
        return {
            title: "Dashboard",
            showModal: false,
            loading: false,
        };
    },
    computed: {
        // VuexストアからmenuItemsを取得
        menuItems() {
            return this.$store.getters.menuItems;
        },
        // "Dashboards" を除外したメニュー項目
        filteredMenuItems() {
            console.log(this.menuItems);
            return this.menuItems.filter((menu) => menu.label !== "Dashboards");
        },
    },
    methods: {
        toPage(url) {
            window.location.href = url;
        },
    },
    mounted() {
        this.getUser("user");
    },
};
</script>

<style>
.modal-mask {
    z-index: 10;
    position: fixed;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background-color: rgba(0, 0, 0, 0.5);
    display: flex;
    align-items: center;
    justify-content: center;
}
</style>
